import Header from "./../components/header/Header.tsx";
//import { Chat } from "./chat/Chat";
//import { SignalRProvider } from "../contexts/SignalRContext";
import { GlobalUpdates } from "./GlobalUpdates";
//import "./Layout.css";
import "../global/Global.css";

export const Layout = ({ children }) => {
  return (
    //<SignalRProvider>
      <GlobalUpdates>
          <Header />
          {/*<Chat />*/}
          {children}
      </GlobalUpdates>
    //</SignalRProvider>
  );
};
